import ExtjsReact from "../../common/utils/ExtReact";
import React, { Component } from 'react';

class ExtjsViewAggregationPanel extends ExtjsReact {
    renderExtjsCmp() {
        let me = this,
            timeout = this.props.delayedRender ? 250 : 0;

        setTimeout(() => {
            me.getCmp(this.renderTo)
        }, timeout)
    }

    render() {
        this.renderTo = Util.getUniqueId();

        return (<div id={this.renderTo} style={{ width: 450 }}></div>);
    }

    getCmp = (renderTo) => {
        var me = this,
            props = me.props;

        me.cmp = Ext.create('TL.list.views.ViewAggregation', {
            viewConfig: Ext.clone(props.viewConfig),
            listConfig: props.config,
            padding: "5 0 0 5",
            renderTo: renderTo,
            width: 450,
            isToolbarItems: false,
            shouldFetchCount: props.aggregationColumn.aggregation_value == undefined,
            aggregationType: props.aggregationType,
            aggregationColumn: props.aggregationColumn,
            aggregationValue: props.aggregationColumn.aggregation_value || 0,
            currentViewCount: props.aggregationColumn.current_view_count,
            height: 37,
            listeners: {
                view_aggregation_change: (value) => {
                    props.onChange(value);
                },
                view_aggregation_value_change: (value) => {
                    props.onColumnValueChange(value);
                }
            }
            // height: 20,
        })

        me.cmp.setColumns(props.columns)
        return me.cmp;
    }

    getValue = () => this.cmp.getValue()

}

export default ExtjsViewAggregationPanel;